import { CANVAS_TUNING, CORE_TUNING } from "./tuning";
import { isMobileViewport } from "./platform";

export const BOARD_SIZE = CORE_TUNING.boardSize;
export const SCHEMA_VERSION = CORE_TUNING.schemaVersion;
export const MAX_LEVEL = CORE_TUNING.maxLevel;
export const START_LIVES = CORE_TUNING.startLives;
export const MAX_LIVES = CORE_TUNING.maxLives;
export const START_ROTATION_KEYS = CORE_TUNING.startRotationKeys;
export const MAX_ROTATION_KEYS = CORE_TUNING.maxRotationKeys;
export const EXTRA_LIFE_STEP = CORE_TUNING.extraLifeStep;
export const KEY_EARN_STEP = CORE_TUNING.keyEarnStep;
export const BASE_BPM = CORE_TUNING.baseBpm;
export const WARNING_BEATS = CORE_TUNING.warningBeats;
export const BEAT_WINDOW_SEC = CORE_TUNING.beatWindowSec;
export const BEAT_BONUS_FACTOR = CORE_TUNING.beatBonusFactor;
export const DOOM_CLOCK_START_SEC = CORE_TUNING.doomClockStartSec;
export const DOOM_CLOCK_DRAIN_PER_SEC = CORE_TUNING.doomClockDrainPerSec;
export const DOOM_CLOCK_DRAIN_PER_LEVEL = CORE_TUNING.doomClockDrainPerLevel;
export const DOOM_CLOCK_MATCH_REWARD_SEC = CORE_TUNING.doomClockMatchRewardSec;
export const DOOM_CLOCK_BOMB3_BONUS_SEC = CORE_TUNING.doomClockBomb3BonusSec;
export const DOOM_CLOCK_BOMB4_BONUS_SEC = CORE_TUNING.doomClockBomb4BonusSec;
export const DOOM_CLOCK_BOMB5_BONUS_SEC = CORE_TUNING.doomClockBomb5BonusSec;
export const DOOM_CLOCK_WIPE_USE_BONUS_SEC = CORE_TUNING.doomClockWipeUseBonusSec;
export const DOOM_CLOCK_WIPE_MATCHED_TILE_BONUS_SEC = CORE_TUNING.doomClockWipeMatchedTileBonusSec;
export const DOOM_CLOCK_NO_MOVES_PENALTY_SEC = CORE_TUNING.doomClockNoMovesPenaltySec;
export const DOOM_CLOCK_MAX_SEC = CORE_TUNING.doomClockMaxSec;
export const DOOM_CLOCK_GROOVE_CHARGE_BASELINE_SEC = CORE_TUNING.doomClockGrooveChargeBaselineSec;
export const DOOM_CLOCK_CHAIN_BONUS_SEC = CORE_TUNING.doomClockChainBonusSec;
export const DOOM_CLOCK_POWERUP_SWEEP_BONUS_SEC = CORE_TUNING.doomClockPowerupSweepBonusSec;
export const GROOVE_BOMB_TILE_BONUS_FRAC = CORE_TUNING.grooveBombTileBonusFrac;
export const GROOVE_WIPE_MATCHED_TILE_BONUS_FRAC = CORE_TUNING.grooveWipeMatchedTileBonusFrac;
export const SAVE_KEY = "rotatepanic.save.v1";
export const LB_LOCAL_KEY = "rotatepanic.lb.local.v1";
export const SETTINGS_KEY = "rotatepanic.settings.v1";
export const GLOBAL_LEADERBOARD_LIMIT = CORE_TUNING.globalLeaderboardLimit;
export const LOCAL_LEADERBOARD_LIMIT = CORE_TUNING.localLeaderboardLimit;

export const CANVAS_WIDTH = CANVAS_TUNING.width;
export const CANVAS_HEIGHT = CANVAS_TUNING.height;
export const BOARD_PIXEL_SIZE = CANVAS_TUNING.boardPixelSize;
export const BOARD_ORIGIN_X = CANVAS_TUNING.boardOriginX;
export const BOARD_ORIGIN_Y = CANVAS_TUNING.boardOriginY;
export const TILE_PIXEL_SIZE = BOARD_PIXEL_SIZE / BOARD_SIZE;

// Mobile-aware board metrics (call per-frame; the static constants above are the desktop defaults)
export function activeBoardPixelSize(): number {
  return isMobileViewport() ? CANVAS_WIDTH : BOARD_PIXEL_SIZE;
}
export function activeBoardOriginX(): number {
  return isMobileViewport() ? 0 : BOARD_ORIGIN_X;
}
export function activeTilePixelSize(): number {
  return activeBoardPixelSize() / BOARD_SIZE;
}

export { isMobileViewport, isLandscapeViewport, computeCanvasDimensions, MOBILE_BREAKPOINT_PX } from "./platform";
export { computeLayout, getLayout, type LayoutMetrics } from "./layout";
